import { useCallback } from 'react'
import { useAppDispatch } from '@/redux/core'
import { PackageInfo, setPackage, useLazyGetPackageInfoQuery } from '@/redux/package'

const useUpdatePackageInfo = () => {
  const dispatch = useAppDispatch()

  const [getPackageInfo] = useLazyGetPackageInfoQuery()

  const updatePackageInfo = useCallback(
    (packageInfo: PackageInfo) => {
      dispatch(setPackage({ [packageInfo.sessionId]: packageInfo }))
    },
    [dispatch],
  )

  const refetchPackageInfo = useCallback(
    async (sessionId: string) => {
      const {
        data: { data },
      } = await getPackageInfo({ sessionId }).unwrap()

      updatePackageInfo(data)
    },
    [getPackageInfo, updatePackageInfo],
  )

  return { updatePackageInfo, refetchPackageInfo }
}

export default useUpdatePackageInfo
